fragment AudienceWidgetFragment on Audience {
    id
    name
    isWebFX
}
